import { orderFlowCloseReason, useOrderFlowContext } from "@src/app/order-flow-context";
import { useOrderInfoContext } from "@src/app/order-info-context";
import Button from "../button/Button";

export interface TimePickerModel {
  title: string;
  noteTitle: string;
  noteText: string;
  chooseTimeText: string;
  ctaText: string;
  collectingFromPostcodeText: string;
  changePostcodeText: string;
}

interface Props {
  data: TimePickerModel;
  extraClassname?: string;
  keepFirstCollection?: boolean;
}

const TimePicker = ({ data, extraClassname, keepFirstCollection }: Props) => {
  const { schedule, session, setFirstCollection, setSchedule, setSession } = useOrderInfoContext();
  const { handleClose, handleContinue } = useOrderFlowContext();

  const handleWeekdayClick = (weekDay: number) => {
    if (!keepFirstCollection) setFirstCollection(undefined);
    if (!session) {
      setSession("am");
    }

    if (!schedule) {
      setSchedule([weekDay]);
      return;
    }

    const index = schedule.indexOf(weekDay);
    if (index >= 0) {
      setSchedule(schedule.filter((wd) => wd !== weekDay));
    } else {
      setSchedule([...schedule, weekDay]);
    }
  };

  const handleDaySessionClick = (session: string) => {
    setSession && setSession(session);
  };

  const haveSelection = !!schedule?.length && !!session;

  return (
    <div className={`fm-o-time-picker ${haveSelection && "fm-o-time-picker--have-selection"} ${extraClassname ?? ""}`}>
      <h2 className="fm-o-time-picker__title">{data.title}</h2>
      <div className={`fm-o-time-picker__content ${haveSelection ? "fm-o-time-picker__content--have-selection" : ""}`} translate="no" tabIndex={-1}>
        <div className="fm-o-time-picker__days">
          {["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"].map((weekday, index) => (
            <button
              className={"tfm fm-o-time-picker__day fm-o-time-picker__day--" + (schedule?.includes(index) ? "checked" : "unchecked")}
              key={weekday}
              onClick={() => handleWeekdayClick(index)}
            >
              <span>{weekday}</span>
            </button>
          ))}
        </div>
        {!!schedule?.length && (
          <div className="fm-o-time-picker__time">
            <h5 className="fm-o-time-picker__time-title">{data.chooseTimeText}</h5>
            <div className={"fm-o-time-picker__time-group fm-o-time-picker__time-group--" + session}>
              {["am", "pm"].map((s) => (
                <button key={s} className="tfm fm-o-time-picker__time-item" onClick={() => handleDaySessionClick(s)}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}
        {!haveSelection && (
          <div className="fm-o-time-picker__note">
            <div className="fm-o-time-picker__note-title fm-body-bold">{data.noteTitle}</div>
            <div className="fm-o-time-picker__note-text">
              <p style={{ textAlign: "center" }}>{data.noteText}</p>
            </div>
          </div>
        )}
        {!haveSelection && (
          <div className="fm-o-time-picker__postcode-region">
            <div className="fm-o-time-picker__postcode">{data.collectingFromPostcodeText}</div>
            <div className="fm-o-time-picker__change-postcode" onClick={() => handleClose(orderFlowCloseReason.changePostCodeOrLocation)}>
              {data.changePostcodeText}
            </div>
          </div>
        )}
      </div>
      {haveSelection && (
        <div className="fm-o-time-picker__actions">
          <Button text={data.ctaText} onClick={handleContinue} mainClass="fm-o-time-picker__continue-btn" styleModifier={["fm-a-button--blue"]} />
        </div>
      )}
    </div>
  );
};

export default TimePicker;
